import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Account = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    const userData = localStorage.getItem('user');
    
    if (!token) {
      navigate('/login');
      return;
    }

    if (userData) {
      setUser(JSON.parse(userData));
      setLoading(false);
    } else {
      // Fetch user data
      fetch('https://auth.prompteh.com/me', {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Unauthorized');
          }
          return response.json();
        })
        .then(data => {
          localStorage.setItem('user', JSON.stringify(data));
          setUser(data);
        })
        .catch(() => {
          localStorage.removeItem('auth_token');
          localStorage.removeItem('user');
          navigate('/login');
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
    navigate('/');
  };

  const handleUpgrade = () => {
    // This would typically link to a payment processor
    alert('Upgrade functionality will be implemented in the future.');
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-md my-8">
      <h2 className="text-2xl font-semibold mb-4">Your Account</h2>
      
      <div className="mb-6 p-4 bg-gray-50 rounded-lg">
        <p className="mb-2"><span className="font-semibold">Email:</span> {user.email}</p>
        <p className="mb-2"><span className="font-semibold">Current Tier:</span> <span className={user.tier === 'paid' ? 'text-green-600 font-semibold' : ''}>{user.tier === 'paid' ? 'Premium' : 'Free'}</span></p>
      </div>
      
      {user.tier === 'free' && (
        <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <h3 className="text-lg font-semibold mb-2">Upgrade to Premium</h3>
          <ul className="list-disc pl-5 mb-4 text-gray-700">
            <li>Ad-free experience</li>
            <li>No tracking</li>
            <li>Priority support</li>
            <li>Advanced prompt features</li>
          </ul>
          <button 
            onClick={handleUpgrade}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Upgrade Now
          </button>
        </div>
      )}
      
      <div className="flex justify-end">
        <button 
          onClick={handleLogout}
          className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
        >
          Log Out
        </button>
      </div>
    </div>
  );
};

export default Account;
